import React, { useEffect, useState } from "react";
import {
    Box,
    Button,
    Paper,
    TextField,
    MenuItem,
    Typography,
    Grid,
    TableContainer,
    Table,
    TableHead,
    TableBody,
    IconButton,
    Snackbar,
} from "@mui/material";
import {
    ActionMsg,
    Breadcrumb,
    Cancel,
    CTSinput,
    CTSinputNo,
    HandleCloseSnackbar,
    StyledTableCell,
    StyledTableRow,
    useMessageHandler,
} from "../../reusableComponent/Reusables";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import AddIcon from "@mui/icons-material/Add";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import SaveIcon from "@mui/icons-material/Save";
import styles from "../../../styles.module.css";
import {
    addDeliveryChallan,
    getProductList,
    editDeleteDeliveryChallan,
    getDeliveryChallanList,
    getDriverList,
    getCustomerList,
    getUOMList,
    getVehicleList,
    getUnitList,
    getScheduleEntryList,
    getDepotList,
    getSupplierList,
    editDeleteDeliverycustomerChallan,
    addDeliverycustomerChallan,
} from "../../../actions/actions";
import dayjs from "dayjs";
import productMasterService from "../../../services/masters/productMaster.Service";
import vehicleMasterService from "../../../services/masters/vehicleMaster.Service";
import depotMasterService from "../../../services/masters/depotMaster.Service";
import driverMasterService from "../../../services/masters/driverMaster.Service";
import customerMasterService from "../../../services/masters/customerMaster.Service";
import deliveryChallanCustomerService from "../../../services/deliveryChallanCustomerService";
import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";

const DeliveryChallanCustomerAdd = () => {
    // const classes = useStyles();
    const dispatch = useDispatch();
    /////////////////////////

    //     const { driver } = useSelector((state) => state.driver);

    //     useEffect(() => {
    //         dispatch(getDriverList({ page: 0, size: 10, searchKey: "" }));
    //         dispatch(getVehicleList({ page: 0, size: 10, searchKey: "" }));
    //     }, [dispatch]);
    //     ////
    //     const { customer } = useSelector((state) => state.customer);
    //     const { depot } = useSelector((state) => state.depot)


    //     useEffect(() => {
    //         dispatch(getCustomerList({ page: 0, size: 10, searchKey: "" }));
    //         dispatch(getUOMList({ page: 0, size: 999, searchKey: "" }));
    //         dispatch(getSupplierList({ page: 0, size: 999, searchKey: "" }));

    //         dispatch(getDepotList({ page: 0, size: 999, searchKey: "" }));
    //         dispatch(getScheduleEntryList({ page: 0, size: 999, searchKey: "" }));
    //     }, [dispatch]);

    //     ////////
    //     const { product } = useSelector((state) => state.product);
    //   const { vehicle } = useSelector((state) => state.vehicle);


    //     useEffect(() => {
    //         dispatch(getProductList({ page: 0, size: 10, searchKey: "" }));
    //             dispatch(getVehicleList({ page: 0, size: 10, searchKey: "" }));
    //     }, [dispatch]);

    const [driver, setDriver] = useState([]);
    const [depot, setDepot] = useState([]);
    const [product, setProduct] = useState([]);
    const [vehicle, setVehicle] = useState([]);
    const [customer, setCustomer] = useState([]);

    useEffect(() => {
        async function fetchData() {
            try {
                const [driverData, depotData, productData, customerData, vehicleData] = await Promise.all([
                    driverMasterService.getDriverList({ page: 0, size: 999, searchKey: "" }),
                    depotMasterService.getDepotList({ page: 0, size: 999, searchKey: "" }),
                    productMasterService.getProductList({ page: 0, size: 999, searchKey: "" }),
                    customerMasterService.getCustomerList({ page: 0, size: 999, searchKey: "" }),
                    vehicleMasterService.getVehicleList({ page: 0, size: 999, searchKey: "" }),

                ]);

                setDepot(depotData);
                setDriver(driverData);
                setProduct(productData);
                setCustomer(customerData);
                setVehicle(vehicleData);

            } catch (error) {
                console.error("Data fetching failed", error);
            }
        }

        fetchData();
    }, []);


    /////////////////////////

    const login_details = sessionStorage.getItem('loginUser');
    const userD = JSON.parse(login_details);
    const userInfo = userD.result.userInfo;
    const { handleSubmit } = useForm();
    const urlLocation = useLocation();
    const editInfo = urlLocation.state;
    const editData = editInfo && editInfo;
    const editid = editData ? editData.supplier_quotation_id : null;
    let navigate = useNavigate();
    const [isSet, setIsSet] = useState(false);
    const [total, setTotal] = useState(0);
    const [total_tax, setTotalTax] = useState(editData ? editData.total_tax : 0);
    const [gross_total, setGrossTotal] = useState(
        editData ? editData.gross_total : 0
    );
    const [supplier_id, setSupplier] = useState(null);
    const [supplier_quotation_date, setSupplier_quotation_date] = useState(
        new Date()
    );


    const [data, setData] = useState({


        entry_no: editData ? editData.entry_no : "",
        entry_date: editData ? new Date(editData.entry_date).toISOString().split("T")[0] : new Date().toISOString().split("T")[0],
        vehicle_no: editData ? editData.vehicle_no : "",
        driver_name: editData ? editData.driver_name : "",
        vehicle_id: editData ? editData.vehicle_id : "",
        driver_id: editData ? editData.driver_id : "",
        from_depot_id: editData ? editData.from_depot_id : "",
        to_customer_id: editData ? editData.to_customer_id : "",
        table_details: editData ? editData.table_details : "",

    });

    const handleChange = ({ target }) => {
        const value = target.value;
        const name = target.name;

        setData((prevData) => ({
            ...prevData,
            [name]: value,
        }));

        if (name === "driver_name") {
            const selectedDriver = driver.find((driver) => driver.driver_name === value);
            if (selectedDriver) {
                setData((prevData) => ({
                    ...prevData,
                    driver_id: selectedDriver.driver_id, // Save driver_id
                }));
            } else {
                setData((prevData) => ({
                    ...prevData,
                    driver_id: "", // Reset driver_id if no match
                }));
            }
        }

        // Handle vehicle selection
        if (name === "vehicle_no") {
            const selectedVehicle = vehicle.find((vehicle) => vehicle.vehicle_no === value);
            if (selectedVehicle) {
                setData((prevData) => ({
                    ...prevData,
                    vehicle_id: selectedVehicle.vehicle_id, // Save vehicle_id
                }));
            } else {
                setData((prevData) => ({
                    ...prevData,
                    vehicle_id: "", // Reset vehicle_id if no match
                }));
            }
        }


        if (name === "customer_name") {
            const selectedCustomer = customer.find(
                (cust) => cust.cust_name === value
            );
            if (selectedCustomer) {
                setData((prevData) => ({
                    ...prevData,
                    route_id: selectedCustomer.route_id,
                    delivery_address: selectedCustomer.cust_address,
                }));
            } else {
                setData((prevData) => ({
                    ...prevData,
                    route_id: "",
                    delivery_address: "",
                }));
            }
        }
    };

    const handleChangeDriver = ({ target }) => {
        const value = target.value;

        setData((prevData) => ({
            ...prevData,
            driver_name: value,
        }));
    };

    const handleChangeDeliveryChallan = (event, newValue) => {
        setSupplier(newValue);
    };
    const handleChangeQuotationDate = (date) => {
        setSupplier_quotation_date(date);
    };

    const onSubmit = async (event) => {

        const dcData = {
            ...data,
            delivery_challan_customer_id: editData ? editData.delivery_challan_customer_id : undefined,
            modified_at: dayjs().format('YYYY-MM-DD HH:mm:ss'),
            modified_by: editData ? userInfo.user_id : null,
            created_at: dayjs().format('YYYY-MM-DD HH:mm:ss'),
            created_by: editData ? editData.created_by : userInfo.user_id,
            table_details: JSON.stringify((table_details || [])),
            changedUpdatedValue: "edit",
        };

        try {
            if (editData) {
                await deliveryChallanCustomerService.editDeleteDeliverycustomerChallan(dcData);
            } else {
                await deliveryChallanCustomerService.addDeliverycustomerChallan(dcData);
            }
            setSuccessMessage(editData ? "Updated successfully" : "Added successfully");
            setTimeout(() => navigate(-1), 1000);
        } catch (error) {
            setSuccessMessage("Error occurred");
        }
    };

    const [isUpdateArray, setIsUpdateArray] = useState(false);
    const [table_details, setTable_details] = useState(() => {
        if (editData) {
            try {
                return JSON.parse(editData.table_details);
            } catch (error) {
                console.error("Failed to parse table_details:", error);
                return [
                    {
                        sr_no: "",
                        product: "",
                        prod_id: "",
                        product_description: "",
                        cyl_no: "",
                        qtyk: "",
                        qtyc: "",
                    },
                ];
            }
        } else {
            return [
                {
                    sr_no: "",
                    product: "",
                    prod_id: "",
                    product_description: "",
                    cyl_no: "",
                    qtyk: "",
                    qtyc: "",
                },
            ];
        }
    });


    const handleChangeInput = (e, i) => {
        const array = [...table_details];
        let result = array[i];
        result[e.target.name] = e.target.value;
        result.srno = i + 1;
        array[i] = result;
        setTable_details(array);
        if (e.target.name === "product") {
            const selectedProduct = product.find(
                (product) => product.prod_code === e.target.value
            );
            console.log("Selected Product:", selectedProduct);
            if (selectedProduct) {
                result["product_description"] = selectedProduct.prod_description;
                result["prod_id"] = selectedProduct.prod_id;
            } else {
                result["product_description"] = "";
                result["prod_id"] = "";
            }
        }


        setIsUpdateArray(isUpdateArray ? false : true);
        // ---------------------------
        let tltAmt = result["total"] ? result["total"] : 0;
        let qty = result["quantity"] ? result["quantity"] : 0;
        let rate = result["unit_price"] ? result["unit_price"] : 0;
        let gst = result["tax_code"] ? result["tax_code"] : 0;

        if (e.target.name == "quantity") {
            qty = parseFloat(e.target.value);
        }
        if (e.target.name == "unit_price") {
            rate = parseFloat(e.target.value);
        }
        if (e.target.name == "tax_code") {
            gst = parseFloat(e.target.value);
        }

        let basicAmt = parseFloat(qty) * parseFloat(rate);
        let gstAmt = (parseFloat(basicAmt) * parseFloat(gst)) / 100;

        tltAmt = parseFloat(basicAmt) + parseFloat(gstAmt);
        result["total"] = parseFloat(basicAmt);
        result["tax_amount"] = parseFloat(gstAmt);
        result["amount"] = parseFloat(tltAmt);
        array[i] = result;

        const reducer = (previousValue, currentValue) =>
            previousValue + currentValue;

        const totalCount =
            table_details &&
            table_details
                .map((value) =>
                    value.total && value.total ? parseFloat(value.total) : 0
                )
                .reduce(reducer);
        setTotal(totalCount);

        const gstamount =
            table_details &&
            table_details
                .map((value) =>
                    value.tax_amount && value.tax_amount
                        ? parseFloat(value.tax_amount)
                        : 0
                )
                .reduce(reducer);
        const totalamount =
            table_details &&
            table_details
                .map((value) =>
                    value.amount && value.amount ? parseFloat(value.amount) : 0
                )
                .reduce(reducer);

        setTotalTax(gstamount);
        // setGrossTotal(totalamount + gstamount);
        setGrossTotal(totalamount);
        setIsSet(isSet ? false : true);
    };

    const handleRemoveDC = (index) => {
        const values = [...table_details];
        values.splice(index, 1);
        setTable_details(values);
        setIsUpdateArray(isUpdateArray ? false : true);
        const reducer = (previousValue, currentValue) =>
            previousValue + currentValue;

        const totalCount =
            values &&
            values
                .map((value) =>
                    value.total && value.total ? parseFloat(value.total) : 0
                )
                .reduce(reducer);
        const gstTotalCount =
            values &&
            values
                .map((value) =>
                    value.tax_amount && value.tax_amount
                        ? parseFloat(value.tax_amount)
                        : 0
                )
                .reduce(reducer);
        const amountTotalCount =
            values &&
            values
                .map((value) =>
                    value.amount && value.amount ? parseFloat(value.amount) : 0
                )
                .reduce(reducer);

        setTotal(totalCount);
        setTotalTax(gstTotalCount);
        // setGrossTotal(amountTotalCount + gstTotalCount);
        setGrossTotal(amountTotalCount);
    };
    const handleAddSPQuotationFields = () => {
        setTable_details([
            ...table_details,
            {
                sr_no: table_details.length + 1,
                prod_id: "",
                product: "",
                product_description: "",
                cyl_no: 0,

            },
        ]);
    };

    // let navigate = useNavigate();
    const [successMessage, setSuccessMessage] = useState(null);
    // const respMsgState = useSelector((state) => state.delivery_challan_customer.message);
    // const { shouldShowMsg, responseMessage } = useMessageHandler(
    //     null,
    //     navigate,
    //     setSuccessMessage,
    //     respMsgState
    // );

    // useEffect(() => { }, [shouldShowMsg, responseMessage]);

    return (
        <Box className={`${styles.cts_page}`} sx={{ padding: '0px !important', margin: '0px !important' }}>
            <Box className={`${styles.body}`}>
                <Breadcrumb routeSegments={[{ name: "DC" }]} />

                <Box>
                    <Box sx={{ display: "flex" }}>
                        <Grid container spacing={2} sx={{ pt: 1.5, pb: 1.5 }}>
                            <Grid item md={7} sm={6} xs={12}>
                                <Box sx={{ display: "flex" }}>
                                    <Typography className={`${styles.header_txt}`}>
                                        Add Delivery Challan Customer
                                    </Typography>
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>

                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Grid container spacing={1}>
                            <Grid item xs={12} sm={6} >
                                <Grid container spacing={0.6}>

                                    <Grid item xs={10} sm={10}>
                                        <Box
                                            sx={{
                                                display: "flex",
                                                flexDirection: { xs: "column", sm: "row" },
                                                alignItems: { xs: "stretch", sm: "center" },
                                            }}
                                        >
                                            <Typography
                                                className={`${styles.label_Txt_add}`}>
                                                From Depot
                                            </Typography>
                                            <CTSinput
                                                select
                                                size="small"
                                                fullWidth
                                                name="from_depot_id"
                                                value={data.from_depot_id}
                                                onChange={handleChange}
                                                InputProps={{
                                                    className: styles.CTSinput_Box,
                                                }}
                                            >
                                                {depot?.map((item) => (
                                                    <MenuItem className={styles.cts_lable} key={item.depot_id} value={item.depot_id}>
                                                        {item.depot_name}
                                                    </MenuItem>
                                                ))}
                                            </CTSinput>
                                        </Box>
                                    </Grid>

                                    <Grid item xs={10} sm={10}>
                                        <Box
                                            sx={{
                                                display: "flex",
                                                flexDirection: { xs: "column", sm: "row" },
                                                alignItems: { xs: "stretch", sm: "center" },
                                            }}
                                        >
                                            <Typography
                                                className={`${styles.label_Txt_add}`}>
                                                To Customer
                                            </Typography>
                                            <CTSinput
                                                select
                                                size="small"
                                                fullWidth
                                                name="to_customer_id"
                                                value={data.to_customer_id}
                                                onChange={handleChange}
                                                InputProps={{
                                                    className: styles.CTSinput_Box,
                                                }}
                                            >
                                                {customer?.map((item) => (
                                                    <MenuItem key={item.cust_id} value={item.cust_id} className={styles.cts_lable}>
                                                        {item.cust_name}
                                                    </MenuItem>
                                                ))}
                                            </CTSinput>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid item xs={12} sm={6} >
                                <Grid container spacing={0.6}>

                                    <Grid item xs={12} sm={6}>
                                        <Box
                                            sx={{
                                                display: "flex",
                                                flexDirection: { xs: "column", sm: "row" },
                                                alignItems: { xs: "stretch", sm: "center" },
                                            }}>
                                            <Typography
                                                className={`${styles.label_Txt_add}`}>
                                                DCC No
                                            </Typography>
                                            <CTSinput
                                                size="small"
                                                fullWidth
                                                type="text"
                                                name="entry_no"
                                                value={data.entry_no}
                                                onChange={handleChange}
                                                InputProps={{
                                                    readOnly: true,
                                                    className: styles.CTSinput_Box,
                                                    style: {
                                                        backgroundColor: "#f0f0f0",
                                                    },
                                                }}
                                            />
                                        </Box>
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                        <Box
                                            sx={{
                                                display: "flex",
                                                flexDirection: { xs: "column", sm: "row" },
                                                alignItems: { xs: "stretch", sm: "center" },
                                            }}>
                                            <Typography
                                                className={`${styles.label_Txt_add}`}>
                                                Entry Date
                                            </Typography>
                                            <CTSinput
                                                size="small"
                                                fullWidth
                                                type="date"
                                                onChange={handleChange}
                                                name="entry_date"
                                                value={data.entry_date}
                                                InputProps={{
                                                    className: styles.CTSinput_Box,
                                                }}
                                            />
                                        </Box>
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                        <Box
                                            sx={{
                                                display: "flex",
                                                flexDirection: { xs: "column", sm: "row" },
                                                alignItems: { xs: "stretch", sm: "center" },
                                            }}
                                        >
                                            <Typography
                                                className={`${styles.label_Txt_add}`}>
                                                Driver Name
                                            </Typography>
                                            <CTSinput
                                                select
                                                size="small"
                                                fullWidth
                                                name="driver_name"
                                                value={data.driver_name}
                                                onChange={handleChange}
                                                variant="outlined"
                                                InputProps={{
                                                    shrink: true,
                                                    className: styles.CTSinput_Box,
                                                }}
                                            >
                                                {driver?.map((driver) => (
                                                    <MenuItem className={styles.cts_lable} key={driver.driver_id} value={driver.driver_name}>
                                                        {driver.driver_name}
                                                    </MenuItem>
                                                ))}
                                            </CTSinput>
                                        </Box>
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                        <Box
                                            sx={{
                                                display: "flex",
                                                flexDirection: { xs: "column", sm: "row" },
                                                alignItems: { xs: "stretch", sm: "center" },
                                            }}
                                        >
                                            <Typography
                                                className={`${styles.label_Txt_add}`}>
                                                Vehicle No
                                            </Typography>
                                            <CTSinput
                                                select
                                                size="small"
                                                fullWidth
                                                name="vehicle_no"
                                                value={data.vehicle_no}
                                                onChange={handleChange}
                                                variant="outlined"
                                                InputProps={{
                                                    shrink: true,
                                                    className: styles.CTSinput_Box,
                                                }}

                                            >
                                                {vehicle?.map((vehicle) => (
                                                    <MenuItem className={styles.cts_lable} key={vehicle.vehicle_id} value={vehicle.vehicle_no}>
                                                        {vehicle.vehicle_no}
                                                    </MenuItem>
                                                ))}
                                            </CTSinput>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid item xs={12} style={{ marginTop: '20px' }}>
                                <Paper sx={{ width: '100%',  }}>
                                    <TableContainer component={Paper} className={`${styles.list_tbl_container}`}>
                                        <Table size="small" stickyHeader>
                                            <TableHead>
                                                <StyledTableRow>
                                                    <StyledTableCell
                                                        align="center"
                                                        className={`${styles.table_head}`}
                                                        width="8%"
                                                    >
                                                        Sr No
                                                    </StyledTableCell>

                                                    <StyledTableCell
                                                        align="left"
                                                        className={`${styles.table_head}`}
                                                    >
                                                        Cylinder No
                                                    </StyledTableCell>
                                                    <StyledTableCell
                                                        align="left"
                                                        className={`${styles.table_head}`}
                                                        width="15%"
                                                    >
                                                        Product
                                                    </StyledTableCell>
                                                    <StyledTableCell
                                                        align="left"
                                                        className={`${styles.table_head}`}
                                                        width="25%"
                                                    >
                                                        Product Description
                                                    </StyledTableCell>


                                                  
                                                    <StyledTableCell
                                                        align="left"
                                                        className={`${styles.table_head}`}
                                                    >
                                                        QTY
                                                    </StyledTableCell>
                                                    <StyledTableCell
                                                        align="left"
                                                        className={`${styles.table_head}`}
                                                    >
                                                        UOM
                                                    </StyledTableCell>
                                                    <StyledTableCell align="center"
                                                        className={`${styles.table_head}`}
                                                    >Action</StyledTableCell>

                                                </StyledTableRow>
                                            </TableHead>
                                            <TableBody sx={{ backgroundColor: '#fff' }}>
                                                {table_details &&
                                                    table_details.map((row, index) => (
                                                        <StyledTableRow key={index}>
                                                            <StyledTableCell
                                                                align="center">
                                                                {index + 1}
                                                            </StyledTableCell>
                                                            <StyledTableCell
                                                                align="left">

                                                                <CTSinput
                                                                    fullWidth
                                                                    size="small"
                                                                    variant="standard"
                                                                    type="text"
                                                                    name="product"
                                                                    value={row.product}
                                                                    onChange={(e) => handleChangeInput(e, index)}
                                                                    InputProps={{ disableUnderline: true, }}
                                                                    select // Add a select dropdown for product codes
                                                                >

                                                                    {product.map((product) => (
                                                                        <MenuItem className={`${styles.cts_lable}`}
                                                                            key={product.prod_id}
                                                                            value={product.prod_code}
                                                                        >
                                                                            {product.prod_code}
                                                                        </MenuItem>
                                                                    ))}
                                                                </CTSinput>
                                                            </StyledTableCell>
                                                            <StyledTableCell
                                                                align="left">

                                                                <CTSinput
                                                                    fullWidth
                                                                    size="small"
                                                                    variant="standard"
                                                                    InputProps={{
                                                                        disableUnderline: true,
                                                                        readOnly: true,
                                                                        style: {
                                                                            backgroundColor: "#f0f0f0",
                                                                        },
                                                                    }}
                                                                    type="text"
                                                                    name="product_description"
                                                                    value={row.product_description} // This should be auto-filled based on the selected product
                                                                    onChange={(e) => handleChangeInput(e, index)} // If you want to allow manual editing
                                                                />
                                                            </StyledTableCell>
                                                            <StyledTableCell align="left">
                                                                <CTSinput
                                                                    fullWidth
                                                                    size="small"
                                                                    placeholder="Enter Cyl No"
                                                                    variant="standard"
                                                                    // InputProps={{
                                                                    //     disableUnderline: true,
                                                                    // }}
                                                                    type="text"
                                                                    name="cyl_no"
                                                                    value={row.cyl_no}
                                                                    onChange={(e) => handleChangeInput(e, index)}
                                                                />
                                                            </StyledTableCell>

                                                            <StyledTableCell align="left">
                                                                <CTSinput
                                                                    fullWidth
                                                                    size="small"
                                                                    placeholder="Enter QTY"
                                                                    variant="standard"
                                                                    // InputProps={{
                                                                    //     disableUnderline: true,
                                                                    // }}
                                                                    type="text"
                                                                    name="qtyk"
                                                                    value={row.qtyk}
                                                                    onChange={(e) => handleChangeInput(e, index)}
                                                                />
                                                            </StyledTableCell>
                                                            <StyledTableCell align="left">
                                                                <CTSinput
                                                                    fullWidth
                                                                    placeholder="Enter UOM"
                                                                    size="small"
                                                                    variant="standard"
                                                                    // InputProps={{
                                                                    //     disableUnderline: true,
                                                                    // }}
                                                                    type="text"
                                                                    name="uom"
                                                                    value={row.uom}
                                                                    onChange={(e) => handleChangeInput(e, index)}
                                                                />
                                                            </StyledTableCell>
                                                            <StyledTableCell align="center">
                                                                <Box
                                                                    style={{
                                                                        display: "flex",
                                                                        justifyContent: "center",
                                                                    }}
                                                                >
                                                                    <IconButton
                                                                        size="small"
                                                                        onClick={handleAddSPQuotationFields}
                                                                    >
                                                                        <AddIcon
                                                                            sx={{
                                                                                fontSize: "16px",
                                                                                color: "#1b52d1",
                                                                                border: "1px solid #1b52d1",
                                                                                borderRadius: "50%",
                                                                            }}
                                                                        />
                                                                    </IconButton>
                                                                    {index === 0 ? (
                                                                        <IconButton
                                                                            disabled
                                                                            size="small"
                                                                            style={{ fontSize: "12px", color: "red" }}
                                                                        >
                                                                            <DeleteForeverIcon
                                                                                sx={{
                                                                                    color: "#c0c0c0",
                                                                                    fontSize: "18px",
                                                                                }}
                                                                            />
                                                                        </IconButton>
                                                                    ) : (
                                                                        <IconButton
                                                                            size="small"
                                                                            onClick={() => handleRemoveDC(index)}
                                                                            style={{ fontSize: "12px", color: "red" }}
                                                                        >
                                                                            <DeleteForeverIcon
                                                                                sx={{ fontSize: "18px" }}
                                                                            />
                                                                        </IconButton>
                                                                    )}
                                                                </Box>
                                                            </StyledTableCell>
                                                        </StyledTableRow>
                                                    ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Paper>
                            </Grid>
                            <Grid item xs={12} className={`${styles.grid_input}`}>
                                <Box className={`${styles.btn_container}`}>
                                    <Box>
                                        <Button
                                            id={`${styles.btn_save}`}
                                            type="submit"
                                        >
                                            <SaveIcon className={`${styles.btn_cancel_txt}`} />{" "}
                                            <Typography className={`${styles.btn_cancel_txt}`}> {editData ? "Update" : "Save"}</Typography>
                                        </Button>
                                    </Box>
                                    <Box>
                                        <Cancel />
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>
                    </form>
                </Box>


                <ReusableSnackbar
                    open={!!successMessage}
                    onClose={(event, reason) => {
                        if (reason !== 'clickaway') {
                            setSuccessMessage("");
                        }
                    }}
                    message={successMessage}
                    autoHideDuration={2000}
                    vertical="top"
                    horizontal="right"
                />
            </Box>
        </Box>
    );
};
export default DeliveryChallanCustomerAdd;
